import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setView, previousView } from 'actions/todos';
import { templateView } from 'components/projects/taskList/constants';
import useDeleteTemplate from '../hooks/useDeleteTemplate';
import { translate } from 'translations/i18n';

import Confirm from './Confirm';

const TemplateConfirmView = () => {
  const dispatch = useDispatch();
  const id = useSelector((state) => state.todos.templates.currentTemplateId);

  const { deleteTemplate } = useDeleteTemplate({
    onSuccess: async () => {
      dispatch(setView({ view: templateView.LIST }));
    },
  });
  return (
    <Confirm
      cancelAction={() => dispatch(previousView())}
      confirmAction={() =>
        deleteTemplate({
          variables: {
            input: {
              id,
            },
          },
        })
      }
      confirmLabel={translate('common.delete')}
      message={translate('projects.taskList.templates.deleteConfirm')}
    />
  );
};

TemplateConfirmView.propTypes = {};

export default TemplateConfirmView;
